import { render, staticRenderFns } from "./RiwayatAdmin.vue?vue&type=template&id=3071c54b&scoped=true"
import script from "./RiwayatAdmin.vue?vue&type=script&lang=js"
export * from "./RiwayatAdmin.vue?vue&type=script&lang=js"
import style0 from "./RiwayatAdmin.vue?vue&type=style&index=0&id=3071c54b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3071c54b",
  null
  
)

export default component.exports